<template>
  <div
    class="error-window"
    :style="{ backgroundImage: 'url(' + bgart + '), none' }"
  >
    <div class="error-window-text">
      <h3>
        Oops! Something<br />went wrong<span v-if="!hideTellTeacher"
          >, please tell your teacher</span
        >.
      </h3>
      <button @click.stop.prevent="relogin">Reload</button>
    </div>
  </div>
</template>

<script>
import KeyboardErrorBg from 'assets/images/keyboardErrorBg.png';

export default {
  props: {
    hideTellTeacher: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      bgart: KeyboardErrorBg
    };
  },
  methods: {
    relogin() {
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
.error-window {
  width: 700px;
  height: 404px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 8px;
}
.error-window-text {
  width: 500px;
  padding: 20px 0 0 200px;
  text-align: center;
  button {
    background-color: green;
    padding: 10px 20px;
    font-size: 28px;
    line-height: 30px;
    border-radius: 5px;
    border: none;
    color: white;
    text-transform: uppercase;
    font-family: "hwtfutura-bold";
  }
  h3 {
    text-transform: uppercase;
    font-size: 32px;
    color: #2e70be;
    font-family: "hwtfutura-bold";
  }
}
</style>
